
import { LocalNavComponent } from "../local-nav.component"
import { DarkModeSwitcher } from '../dark-mode/dark-mode-switcher.component'
import { TbwNewsletterFormComponent } from '../newsletter/tbw-newsletter-form.component'


const components = [
  // Dev
  { name: 'tbw-local-nav', component: LocalNavComponent },

  // Design
  { name: 'tbw-dark-mode-switcher', component: DarkModeSwitcher },

  // Newsletter
  { name: 'tbw-newsletter-form', component: TbwNewsletterFormComponent },

]


export const registerComponents = () => {
  components.forEach(component => {
    customElements.define(component.name, component.component)
  })
}